import { api } from "./api";

export const PUBLIC_RESTAURANT_CACHE_TTL_MS = 15_000;

const publicRestaurantCache = new Map();

function cacheKeyFor(slug, branchId) {
  return `${slug}:${branchId ?? ""}`;
}

function clearCacheEntry(cacheKey, entry) {
  if (publicRestaurantCache.get(cacheKey) === entry) {
    publicRestaurantCache.delete(cacheKey);
  }
}

function loadPublicRestaurant(slug, branchId) {
  const cacheKey = cacheKeyFor(slug, branchId);
  const existing = publicRestaurantCache.get(cacheKey);

  if (existing && existing.expiresAt > Date.now()) {
    return existing.promise;
  }

  if (existing) {
    window.clearTimeout(existing.expiryTimer);
    clearCacheEntry(cacheKey, existing);
  }

  let entry;
  const promise = api.get(`/public/restaurants/${slug}`, {
    params: { branch_id: branchId },
  }).then(({ data }) => data).catch((error) => {
    window.clearTimeout(entry.expiryTimer);
    clearCacheEntry(cacheKey, entry);
    throw error;
  });

  entry = {
    promise,
    expiresAt: Date.now() + PUBLIC_RESTAURANT_CACHE_TTL_MS,
    expiryTimer: null,
  };
  entry.expiryTimer = window.setTimeout(() => {
    clearCacheEntry(cacheKey, entry);
  }, PUBLIC_RESTAURANT_CACHE_TTL_MS);
  publicRestaurantCache.set(cacheKey, entry);

  return promise;
}

export function prefetchPublicRestaurant(slug, branchId) {
  return loadPublicRestaurant(slug, branchId);
}

export function getPublicRestaurant(slug, branchId) {
  return loadPublicRestaurant(slug, branchId);
}

export function getPublicRestaurantByBranchCode(slug, branchCode) {
  return api.get(`/public/restaurants/${slug}`, {
    params: { branch_code: branchCode },
  }).then(({ data }) => data);
}